import { connect } from 'react-redux';
import { get } from 'lodash';

import { isUserLoggedIn } from 'apps/user/helpers';

import PrimaryBar from '../components/PrimaryBar';

export default connect(state => ({
  topNavigation: state.topNavigation,
  isLoggedIn: isUserLoggedIn(state.user),
  seasonalEvents: state.topNavigation.events,
  subscriptionsNavigationEnabled: get(state, 'user.eligibilityDetails.subscriptionsNavigationEnabled'),
  user: state.user,
}))(PrimaryBar);
